export default __webpack_public_path__ + "icon_roadside_assistance.svg";